<!-- 此组件用于product页面的图片廊的展示 -->
<template>
  <a href="https://tccc.qcloud.com/web/im/chat/?webAppId=3941632bfd3545b0d16fd30339f49f7f" target="_blank">
    <img :src="this.img" alt="客服">
  </a>
</template>

<script>
export default {
  name: 'pictures',
  data () {
    return {
      img: require('../assets/customer-service.png')
    }
  }
}
</script>

<style scoped>
  img {
    position: fixed;
    right: 3rem;
    bottom: 4rem;
    width: 5rem;
  }

  @media screen and (max-width: 700px) {
    img {
      width: 3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomerService.vue